import { render, staticRenderFns } from "./ReciprocalExchange.vue?vue&type=template&id=cdbbfcea&scoped=true"
import script from "./ReciprocalExchange.vue?vue&type=script&lang=js"
export * from "./ReciprocalExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbbfcea",
  null
  
)

export default component.exports